module.exports = __webpack_public_path__ + "img/Dantam Makeover 24.5a290ae0.jpg";